import { cn } from '@/context/global/utils/cn';

interface PlayWarningProps {
  className?: string;
}

const PlayWarning = ({ className }: PlayWarningProps) => {
  return (
    <svg
      className={cn('text-ais-green', className)}
      width="110"
      height="127"
      viewBox="0 0 110 127"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.6768 126.22C10.5709 126.216 8.50236 125.664 6.67454 124.618C2.55869 122.286 0 117.758 0 112.843V13.3771C0 8.44839 2.55869 3.93467 6.67454 1.60236C8.54589 0.526872 10.6718 -0.0261975 12.83 0.000953633C14.9882 0.0281048 17.0995 0.634482 18.9432 1.7567L103.953 52.6423C105.724 53.7532 107.185 55.2959 108.197 57.1256C109.21 58.9554 109.741 61.0123 109.741 63.1034C109.741 65.1946 109.21 67.2515 108.197 69.0812C107.185 70.911 105.724 72.4537 103.953 73.5646L18.9295 124.464C17.0427 125.605 14.8816 126.212 12.6768 126.22Z"
        fill="#444444"
      />
      <path
        d="M41.5673 75.0959H32.8754L30.5078 32.6074H43.9349L41.5673 75.0959Z"
        fill="currentColor"
      />
      <path
        d="M43.935 86.2975C43.935 90.0157 40.9301 93.0266 37.2194 93.0266C33.5088 93.0266 30.5039 90.0157 30.5039 86.2975C30.5039 82.5793 33.5128 79.5684 37.2194 79.5684C40.9261 79.5684 43.935 82.5793 43.935 86.2975Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default PlayWarning;
